import { SET_ISRECONNECTING } from "./types";

const setIsReconnecting = (isReconnecting) => async (dispatch) => {
    dispatch({ type: SET_ISRECONNECTING, isReconnecting });
};

export default setIsReconnecting;
